import axios from 'axios';

const selectHopperLot = function (td) {
  const row = $(td).parents('tr');
  const orderId = $('.js-batch-order-id').val();
  const hopperId = row.find('.batch_hopper_select').val();
  const lotSelect = row.find('.batch_hopper_lot_select');

  const getHopperLot = async () => {
    try {
      const response = await axios.get('/product_lot_by_hopper.json', {
        params: { hopper_id: hopperId, production_order_id: orderId },
      });
      lotSelect.empty();
      lotSelect.append(
        $('<option>', {
          text: response.data.code_and_product,
          value: response.data.id,
        })
      );
      lotSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  };
  getHopperLot();
};

document.addEventListener('turbolinks:load', () => {
  if ($('.edit_batch').length) {
    $('.batch_hopper_select').on('change', (e) => {
      selectHopperLot(e.currentTarget);
    });
  }
  $('#batch_hopper_lots_table').on('cocoon:after-insert', () => {
    $('select').select2({});
    $('.batch_hopper_select').on('change', (e) => {
      selectHopperLot(e.currentTarget);
    });
  });
});
